// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#login-image-panel[data-v-96adbc2c]{box-shadow:inset 0 1px 13px 0 rgba(141,141,153,.53);background-color:#2c055e;background-image:url(/rctiled.jpg);background-image:url(/rctiled.webp);background-size:cover;background-position:50%}", ""]);
// Exports
module.exports = exports;
